import script from "./NotificationMessageDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./NotificationMessageDialog.vue?vue&type=script&setup=true&lang=js"

import "./NotificationMessageDialog.vue?vue&type=style&index=0&id=adf1622c&scoped=true&lang=scss"

import exportComponent from "../../../consumer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-adf1622c"]])

export default __exports__